import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

const CONFLUENCE_SLIDE_CLIENT_ID_PREFIX = 'confluence-slide';

export const getConfluenceSlidesClientId = (contentId: string): ClientId =>
	client(`${CONFLUENCE_SLIDE_CLIENT_ID_PREFIX}-${contentId}`);
